import {
    createVNode as _$cv,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Tabs} from '../tabs';
import {getRestProps} from '../utils';
import {makeStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, children, vertical, size, value} = this.get();
    const { k } = this.config;
    
    const classNameObj = {
        [`${k}-anchor`]: true,
        [className]: className,
        [`${k}-anchor-vertical`]: vertical,
        [makeStyles(k, vertical)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, (
        _$cc(Tabs, {
            'vertical': vertical,
            'size': size,
            'children': children,
            'ev-$model:value': function($v) {
                $this.set('value', $v);
            },
            'value': $this.get('value')
        })
    ));
};